import { Component, Prop, h, State, Element, Listen, Watch, Host, Event, EventEmitter } from '@stencil/core';
import { translations } from './translations';
import { CustomernumberSelectori18n } from './pn-customernumber-selector-types';
import { MarketWebContextService } from '../../../globals/MarketWebContextService';
import { MarketWebLoginManager } from '../../../globals/MarketWebLoginManager';
import { angle_down, angle_up } from "pn-design-assets/pn-assets/icons";

@Component({
  tag: 'pn-customernumber-selector',
  styleUrl: 'pn-customernumber-selector.scss',
})
export class PnCustomernumberSelector {
  @Element() hostElement: Element;

  @Prop({ mutable: true, reflect: true }) language: string = 'sv';
  @Prop({ mutable: true, reflect: true }) open: boolean = false;

  @Prop() heading: string = '';
  @Prop() description: string = '';

  @State() i18n: CustomernumberSelectori18n = translations['en'];

  componentWillLoad() {
    this.init();
  }

  init() {
    this.setTranslations();
  }

  setTranslations() {
    if (this.language && translations[this.language]) {
      this.i18n = translations[this.language];
    }
  }

  render() {
    return (
      <Host>
        <div class="customernumber-container">
          <button class="customernumber-toggle" aria-label={this.i18n.toggleLinkTitleText} onClick={() => (this.open = !this.open)}>
            <div class="customernumber-selected">
              <strong class="customernumber-selected-title">{this.heading}</strong>
              <div class="customernumber-selected-description">{this.description}</div>
            </div>
            <pn-icon icon={this.open ? angle_up : angle_down} small="false" color="blue700" />
          </button>
          <div class="customernumber-options">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
